export default {
      id: "Exclude-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/icons.svg#Exclude",
      toString: function () {
        return this.url;
      }
    }